import React, { useState } from 'react';
import { FileOutlined, SettingOutlined, LayoutOutlined, BugOutlined } from '@ant-design/icons';
import { Menu, Checkbox } from 'antd';
import {exportNetwork} from "./Export.js";
import {nodesExt, edgesExt, anyEvidence} from './Flow.js';
import {handleFile} from "./Import.js";
import {getNodeNamesOnly, setNodeNamesOnly} from "./UserSettings.js";
import { setRefreshNodes } from './App.js';

import '../css/header.css';

import { useAuth0 } from "@auth0/auth0-react";



/*
Top bar of the app. 
*/

//create your forceUpdate hook
export function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update state to force render
}

function Header({setImport, setNewNet, openCloseSettings, forceUpdateApp}) {
    const forceUpdate = useForceUpdate();

const { logout } = useAuth0();

    const items = [
        {
          label: 'File',
          key: 'FileMenu',
          icon: <FileOutlined />,
          children: [
             {
              label: "Logout",
              key: "logout",
              onClick: () => {
               logout({
                 logoutParams: {
                   returnTo: window.location.origin,
                  }
                 });
              }
             }, 
	     {
              type: 'group',
              label: 'Network',
              children: [
                { //New Network
                  label: "Wipe and New Network",
                  key: 'newNet',
                  onClick: () => {
                    setNewNet();
                  }
                }
              ],
            },
                    ],
        },
                  

        {
          label: 'View',
          key: 'ViewMenu',
          icon: <LayoutOutlined />,
          children: [
            {
              label: <>Node names only<Checkbox checked={getNodeNamesOnly()} style={{marginLeft:"10px"}}/></>,
              key: 'nodeNames',
              onClick: () => {
                setNodeNamesOnly(!getNodeNamesOnly());
                setRefreshNodes();
                forceUpdateApp();
              }
            },
          ] 
        },

        

        {
          label: 'Settings',
          key: 'SettingsMenu',
          icon: <SettingOutlined/>,
          onClick: () => {
            openCloseSettings();
          },
        },
      ];

  return (
    <>
    <Menu selectable={false} mode="horizontal" items={items}/> {/*triggerSubMenuAction="click"/> */}
    </>
  );  

};

export default Header;

